import clsx from "clsx";
export const cn = clsx;
export const statuses: Record<string, string> = {
  active: "bg-emerald-100 text-emerald-800",
  draft: "bg-slate-100 text-slate-700",
  pending: "bg-amber-100 text-amber-800",
  paid: "bg-emerald-100 text-emerald-800",
  failed: "bg-rose-100 text-rose-800",
  shipped: "bg-sky-100 text-sky-800"
};
